import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fargo-search" }
const _hoisted_2 = { class: "search-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "ruleForm",
      inline: true,
      "label-position": "left",
      model: _ctx.searchFormData,
      "label-width": "100px",
      class: "demo-form-inline custom-class",
      "popper-class": "custom-class"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchList, (item, itemIdx) => {
          return (_openBlock(), _createBlock(_component_el_form_item, {
            key: itemIdx + 'itemIdx',
            label: item.label,
            prop: item.model,
            "popper-class": "custom-class",
            class: "search-row"
          }, {
            default: _withCtx(() => [
              (item.type === 'input')
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: _ctx.searchFormDataComputed[item.model],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.searchFormDataComputed[item.model]) = $event),
                    modelModifiers: { trim: true },
                    class: "width150",
                    placeholder: item.placeholder || `请输入${item.label}`
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                : _createCommentVNode("", true),
              (item.type === 'select')
                ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 1,
                    modelValue: _ctx.searchFormDataComputed[item.model],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.searchFormDataComputed[item.model]) = $event),
                    class: _normalizeClass(["width150", item.className]),
                    "popper-class": "custom-class",
                    filterable: "",
                    "allow-create": item.allowCreate,
                    clearable: 
            item.clearable === undefined || item.clearable ? true : false
          ,
                    multiple: item.multiple,
                    "collapse-tags": item.multiple,
                    placeholder: item.placeholder || `请选择${item.label}`,
                    onChange: val => _ctx.eventFn(val, item)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (itm, idx) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: idx,
                          label: itm[item.optLable || 'label'],
                          value: itm[item.optValue || 'value']
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "class", "allow-create", "clearable", "multiple", "collapse-tags", "placeholder", "onChange"]))
                : _createCommentVNode("", true),
              (item.type === 'date')
                ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 2,
                    "popper-class": "custom-class",
                    modelValue: _ctx.date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                    type: "daterange",
                    "range-separator": "至",
                    format: "YYYY-MM-DD",
                    "start-placeholder": item.startPlaceholder,
                    "end-placeholder": item.endPlaceholder,
                    onChange: val => _ctx.eventFn(val, item)
                  }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "onChange"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["label", "prop"]))
        }), 128)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "btn-line" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchList[_ctx.searchList.length - 1].setting, (i, v) => {
            return (_openBlock(), _createElementBlock("section", {
              key: 'setting' + v,
              class: "disflex"
            }, [
              (!i.type)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: _normalizeClass(i.class),
                    type: i.color || 'primary',
                    size: i.size,
                    onClick: ($event: any) => (_ctx.search('ruleForm', i.btnType))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(i.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "type", "size", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}